import Vue from 'vue'
import VueRouter from 'vue-router'
import parentDownLoad from "@/components/parentDownLoad";
import teacherDownLoad from "@/components/teacherDownLoad";
import studentDownLoad from '@/components/studentDownLoad'
import teacher from '@/components/phone/teacher'
import parent from '@/components/phone/parent'
import student from '@/components/phone/student'

Vue.use(VueRouter)

const routes = [
    { path: '/parentDownLoad', component: parentDownLoad },
    { path: '/teacherDownLoad', component: teacherDownLoad },
    { path: '/studentDownLoad', component: studentDownLoad },
    { path: '/student', component: student },
    { path: '/teacher', component: teacher },
    { path: '/parent', component: parent }
]


export default new VueRouter({
    routes // (缩写) 相当于 routes: routes
})
